<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <jm-crumbs/>
          <el-form>
            <div class="basic-title"><em>特殊学校</em></div>
            <div
              class="box-content">
              <label class="form-tit">学校信息</label>
              <jm-school-search
                class="jm-input220"
                :country-id="83"
                ref="school_search"
                v-model="school"
              />
            </div>
            <el-button
              type="primary"
              @click="relation()">确定添加</el-button>
          </el-form>
        </div>
      </div>
      <div class="school-name-div">
        <span>已添加的特殊学校(点击可删除)：</span>
        <span
          title="删除学校"
          class="school-name"
          v-for="(item,key) in schoolList"
          :label="item"
          :value="item"
          :key="key"
          @click="cancelRelation(key)">{{ item }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/index.css';
import toolbar from '@/components/tool/toolbar.vue';
import student from '@/pages/student/student';
import { jmSchoolSearch } from '@/components/tool';

export default {
  mixins: [student],
  data() {
    return {
      school: '',
      schoolList: [],
    };
  },
  components: {
    'jm-toolbar': toolbar,
    jmSchoolSearch,
  },
  created() {
    this.getRelation();
  },
  methods: {
    // 添加学校
    relation() {
      if (this.school.sh_id === '') {
        this.$message.error('请选择添加的学校');
        return false;
      }
      this.$http._post({
        url: '/interview/inform/specialSave',
        data: {
          schoolName: this.school.sh_name_cn,
          schoolId: this.school.sh_id,
        },
      }).then(({ result }) => {
        if (result === 0) {
          this.$message({
            type: 'success',
            message: '添加成功!'
          });
          this.getRelation();
        }
      });
    },
    getRelation() {
      this.$http._post({
        url: '/interview/inform/specialRead',
      }).then(({ data }) => {
        this.schoolList = data;
      });
    },
    cancelRelation(id) {
      this.$confirm('此操作将删除此特殊学校, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http._post({
          url: '/interview/inform/deleteSchool',
          data: { id: id },
        }).then((res) => {
          if (res.result === 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getRelation();
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    }
  },
};
</script>
<style>
  .school-name-div{
    margin-left: 50px;
  }
  .school-name{
    display: inline-block;
    background-color: #409EFF;
    color: white;
    padding: 10px;
    border-radius: 5px;
    margin-left: 30px;
    cursor: pointer;
    margin-top: 10px;
  }
</style>
